export enum CutType {
  UNCUT = 0,
  SYMMETRIC = 1,
  ASYMMETRIC = 2,
}
